import { ICommonSettings, IGoogleMapsSetting } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigGoogleMapsSettings } from "./app-settings-config-google-maps";

export interface IConfigGoogleMapsInputState {
  showModal: boolean;
  editingMapsId: string;
}

export interface IConfigGoogleMapsInputProps {
  parentData: string;
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigGoogleMapsInput extends PureComponent<IConfigGoogleMapsInputProps, IConfigGoogleMapsInputState> {
  formInputName = ["", "googleMapsSettingsId"];

  constructor(props: IConfigGoogleMapsInputProps) {
    super(props);
    this.formInputName[0] = props.parentData;

    this.state = {
      showModal: false,
      editingMapsId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingMapsId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingMaps = (id: string) => {
    this.setState({ editingMapsId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentData,
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    // The web and Android sections render this same input, and the Config Manager mounts both at
    // once, so its controls carry the platform they belong to.
    const platform: string = parentData === "androidConfig" ? "android" : "web";

    const options = [
      { id: null, name: "Default" } as unknown as IGoogleMapsSetting,
      ...(commonSettings.googleMapsSettings || [])
    ];
    return (
      <>
        <ConfigGoogleMapsSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingMapsId={this.state.editingMapsId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Configuration"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey={parentData === "androidConfig" ? "android_maps_permissiontext" : "web_googlemaps_info"}
          onAddNew={this.openModal}
          onEdit={this.setEditingMaps}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId={`${platform}MapsConfigurationDropdown`}
          addNewTestId={`${platform}MapsConfigurationAddNewButton`}
          editTestId={`${platform}GoogleMapsSettingEditButton`}
        />
      </>
    );
  }
}
